import React from 'react'

interface LoadingSpinnerProps {
  message?: string
  size?: 'sm' | 'md' | 'lg'
  variant?: 'centered' | 'inline'
  className?: string
}

export function LoadingSpinner({
  message = 'Loading...',
  size = 'md',
  variant = 'centered',
  className = '',
}: Readonly<LoadingSpinnerProps>) {
  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-8 w-8',
    lg: 'h-12 w-12',
  }

  const spinner = (
    <div
      className={`animate-spin rounded-full border-b-2 border-tenant-primary-action-color ${sizeClasses[size]}`}
    />
  )

  if (variant === 'inline') {
    return (
      <div className={`flex items-center gap-2 ${className}`}>
        {spinner}
        {message && (
          <p className="text-sm text-neutral-700" aria-live="polite">
            {message}
          </p>
        )}
      </div>
    )
  }

  // Centered variant (default)
  return (
    <div className={`w-full max-w-[640px] mx-auto ${className}`}>
      <div className="w-full min-h-[300px] md:min-h-[427px] flex flex-col items-center justify-center">
        {spinner}
        {message && (
          <p className="mt-4 text-sm text-neutral-700" aria-live="polite">
            {message}
          </p>
        )}
      </div>
    </div>
  )
}
